module.exports = __webpack_public_path__ + "static/media/A1-The__MovieDB__API.22af8ff1.svg";